import React from "react";
import ApiResponse from "sr/models/ApiResponse";
import { remove } from "sr/utils/axios";

export const deleteAvailability = async (queryParams) => {
    try {
  return await remove<ApiResponse<[]>>(`/cleaner/availability?${queryParams}`).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){

}
};
